import React from 'react';
import { marqueeWords, genreChips } from '../mock';

export function MarqueeStrip() {
  // Duplicate list for seamless loop; unique key = "word-run-index"
  const words = [
    ...marqueeWords.map((w, i) => ({ id: `a-${i}-${w}`, text: w })),
    ...marqueeWords.map((w, i) => ({ id: `b-${i}-${w}`, text: w })),
  ];
  return (
    <div className="relative py-5 bg-violet-400 overflow-hidden border-y border-violet-300">
      <div className="flex whitespace-nowrap animate-marquee">
        {words.map((w) => (
          <div key={w.id} className="flex items-center gap-8 pr-8">
            <span className="font-display text-2xl tracking-wider text-[#1a0b2e]">{w.text}</span>
            <span className="text-[#1a0b2e]/60">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function GenreChipsRow() {
  return (
    <div className="bg-[#0a0612] py-8 border-b border-violet-500/10">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 flex flex-wrap gap-x-8 gap-y-3 justify-center">
        {genreChips.map((g) => (
          <span
            key={g.label}
            className={`font-display text-lg tracking-widest uppercase transition-colors ${
              g.active ? 'text-violet-200' : 'text-white/25'
            }`}
          >
            {g.label}
          </span>
        ))}
      </div>
    </div>
  );
}
